<template>
  <v-app-bar app color="primary" dark>
    <h3>{{ board && board.title || "SatPlanner"}}</h3>
    <div style="width:400px;margin-left:15px;"></div>
    <v-spacer />
    <v-avatar>
      <img :src="getUser().photoURL" />
    </v-avatar>
    <div style="width:400px;margin-left:15px;">
      {{ getUser().displayName }}
      <div />
      {{ getUser().email }}
    </div>
    <router-link to="/home">
      <v-btn fab dark x-small color="blue">
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </router-link>
    <v-btn v-on:click="logout" class="mx-2" fab dark x-small color="deep-orange" title="logout">
      <v-icon>mdi-logout</v-icon>
    </v-btn>

    <div
      style="background-color: white; padding:5px; border-radius: 10px; width:200px; text-align:right"
    >
      <a
        href="/#/offers"
      >month: {{ (Math.round((me.quota_month_remaining / 1000))/1000).toFixed(3) }}MB</a>
      <div />
      <a
        href="/#/offers"
      >spot : {{ (Math.round((me.quota_spot_remaining / 1000))/1000).toFixed(3) }}MB</a>
    </div>
  </v-app-bar>
</template>

<script>
import * as firebase from "firebase";
import * as api from "./api";

let meInterval;
export default {
  name: "AppHeader",
  components: {},
  props: {
    board: Object,
    boards: Array,
  },
  data: () => ({
    me: Object,
  }),
  computed: {},
  mounted() {
    api.me().then((data) => {
      this.me = data;
      window.me = this.me;
    });
    meInterval = setInterval(() => {
      api.me().then((data) => {
        this.me = data;
        window.me = this.me;
      });
    }, 2 * 60 * 1000);
  },
  destroyed() {
    clearInterval(meInterval);
  },
  methods: {
    async logout() {
      await firebase.auth().signOut();
      document.location.replace("/");
    },
  },
};
</script>
